import { useMediaQuery } from '@mui/material';


// TODO: Is this reliable?
export const useIsMobile = () => useMediaQuery('(max-width:600px)');